// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ad4e3663","703":"e87620f6"}[chunkId] + ".chunk.js";
};